var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cg-input-text",style:({'height': _vm.height+'px'})},[_c('div',{staticClass:"cg-input-text-input"},[_c('input',{attrs:{"type":"text","maxlength":_vm.maxLength}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }